module.exports = __webpack_public_path__ + "@/assets/img/022-girl-12.16980aad.svg";